<div class="odata-main-container" [class.closed]="!showPanel" #filterComponent>
  <div
    class="filter-button-container"
    [fxLayoutAlign]="smallSize ? 'start' : 'start center'"
    [fxLayout]="smallSize ? 'column' : 'row'"
  >
    <div fxLayoutAlign="start center" class="filter-name-container">
      @if (!filterMenuOption.hideViewMenu) {
        <lineup-views-menu
          fxFlex
          [title]="filterMenuOption.viewMenuTitle"
          [editable]="!filterMenuOption.readOnlyViewMenu"
          [hideSearch]="filterMenuOption.hideViewMenuSearchBar"
          [selectedView]="selectedView"
          [viewContextId]="filterMenuOption.viewContextId"
          (selectChanged)="onSelectView($event)"
          (create)="onCreateView()"
          (edit)="onEditView($event)"
          (reset)="onSelectView($event)"
        >
        </lineup-views-menu>
      }
      @if (smallSize) {
        <div>
          @if (
            !filterMenuOption.readOnlyViewMenu &&
            selectedView?.isModified &&
            canSaveChanges
          ) {
            <button
              style="margin-left: 8px"
              class="filter-button tall-button"
              mat-stroked-button
              aria-label="Save View"
              (click)="onSaveViewChange()"
            >
              <mat-icon>save</mat-icon>
            </button>
          }
        </div>
      }
    </div>
    <div fxFlex fxLayoutAlign="start center" fxLayoutGap="8px">
      <button
        data-testid="odata-filter-button"
        class="filter-button tall-button"
        mat-stroked-button
        (click)="onOpen()"
      >
        <mat-icon [color]="showFieldDeletedWarning ? 'warn' : ''">{{
          showFieldDeletedWarning ? 'error' : 'filter_list'
        }}</mat-icon>
        <span class="button-text">
          <span
            >{{
              appliedFilters?.length != 0 ? ' ' + appliedFilters?.length : ''
            }}
          </span>
          <span [fxHide]="midSize || filterMenuOption?.hideFilterButtonText">{{
            filterButtonText
          }}</span>
        </span>
      </button>
      @if (!filterMenuOption.hideSearchBar) {
        <div fxFlex>
          <search-bar
            [searchText]="searchText"
            [placeholder]="filterMenuOption.searchPlaceHolder ?? ''"
            (onChange)="search($event)"
            fxFlex="100%"
          ></search-bar>
        </div>
      }
      @if (showDisplayLayoutOptions) {
        <mat-button-toggle-group
          [(ngModel)]="customViewDisplayLayout"
          class="layout-toggle-group"
          (ngModelChange)="displayLayoutChanged.emit($event)"
        >
          @if (filterMenuOption.showListToggleButton) {
            <mat-button-toggle
              [value]="customViewDisplayLayoutEnum.List"
              aria-label="List"
            >
              <mat-icon>view_list</mat-icon>
            </mat-button-toggle>
          }
          @if (filterMenuOption.showTableToggleButton) {
            <mat-button-toggle
              [value]="customViewDisplayLayoutEnum.Table"
              aria-label="Table"
            >
              <mat-icon>grid_on</mat-icon>
            </mat-button-toggle>
          }
          @if (filterMenuOption.showChartToggleButton) {
            <mat-button-toggle
              [value]="customViewDisplayLayoutEnum.Chart"
              aria-label="Chart"
            >
              <mat-icon>bar_chart</mat-icon>
            </mat-button-toggle>
          }
        </mat-button-toggle-group>
      }
      @if (!filterMenuOption.hideManageColumns) {
        <button
          class="columns-button tall-button"
          mat-stroked-button
          (click)="manageColumns.emit()"
          aria-label="Manage columns"
        >
          <mat-icon>view_column</mat-icon>
          @if (!doesPlanAllowManageColumns) {
            <mat-icon class="lock-icon">lock</mat-icon>
          }
        </button>
      }
    </div>
    @if (!smallSize) {
      <div>
        @if (
          !filterMenuOption.readOnlyViewMenu &&
          selectedView?.isModified &&
          canSaveChanges
        ) {
          <button
            class="filter-button tall-button save-view-button"
            mat-stroked-button
            aria-label="Save View"
            (click)="onSaveViewChange()"
          >
            <mat-icon>save</mat-icon>
            <span [fxHide]="midSize"> Save View</span>
          </button>
        }
      </div>
    }
  </div>
  <div [class.filter-panel-open]="showPanel" class="filter-panel">
    <div
      fxLayout="row"
      fxLayoutAlign="space-between center"
      class="filter-panel-title"
    >
      <h4>
        {{ isAdvancedViewMode ? 'Advanced Filter Mode' : 'Quick Filter Mode' }}
        @if (appliedFilters.length > 0 && !isAdvancedViewMode) {
          <button
            class="clear-button"
            mat-stroked-button
            (click)="clearAndApply()"
          >
            Clear All
          </button>
        }
        @if (filterMenuOption.showAiModeButton) {
          <button
            class="ai-mode-button"
            mat-stroked-button
            color="primary"
            (click)="aiModeClick.emit()"
          >
            <mat-icon>auto_awesome</mat-icon>
            AI Mode
          </button>
        }
      </h4>
      @if (!filterMenuOption.hideAdvancedViewButton) {
        <button mat-button color="primary" (click)="onSwitchMode()">
          <mat-icon>compare_arrows</mat-icon>
          {{
            isAdvancedViewMode
              ? 'Switch to Quick Mode'
              : 'Switch to Advanced Mode'
          }}
        </button>
      }
      @if (!isAdvancedViewMode) {
        <p>Results must match <b>all</b> of the following rules</p>
      }
      @if (isAdvancedViewMode) {
        <p>Filters must match <b>OData</b> query syntax</p>
      }
    </div>
    @if (!isAdvancedViewMode) {
      <div class="filter-panel-content">
        @if (selectedFilters.length == 0) {
          <p>No filters applied. Results showing all teams.</p>
        }
        @for (
          selectedFilter of selectedFilters;
          track selectedFilter;
          let i = $index
        ) {
          <div
            class="filters"
            [class.sub-filters-added]="selectedFilter.isSubFilterAdded"
          >
            <odata-filter-item
              [selectedFilter]="selectedFilter"
              [filters]="filters"
              (delete)="deleteFilter(i)"
              (addSubFilter)="addSubFilter(selectedFilter)"
            >
            </odata-filter-item>
            @if (selectedFilter.isSubFilterAdded) {
              <div class="sub-filters">
                <p class="sub-filters-title">Conditions</p>
                @for (
                  selectedSubFilter of selectedFilter.selectedSubFilters;
                  track selectedSubFilter;
                  let i = $index
                ) {
                  <div class="filters">
                    <odata-filter-item
                      [selectedFilter]="selectedSubFilter"
                      [filters]="selectedFilter.filter.subFilter.filters"
                      (delete)="deleteSubFilter(selectedFilter, i)"
                    >
                    </odata-filter-item>
                  </div>
                }
                <button
                  class="add-filter-button"
                  mat-button
                  color="primary"
                  (click)="addSubFilter(selectedFilter)"
                >
                  <mat-icon>add</mat-icon>Add Another Condition
                </button>
              </div>
            }
          </div>
        }
        <button
          class="add-filter-button"
          mat-stroked-button
          color="primary"
          (click)="addFilter()"
        >
          <mat-icon>add</mat-icon>Add Filter
        </button>
      </div>
    }
    @if (selectedView && isAdvancedViewMode) {
      <div class="filter-panel-content">
        <mat-form-field class="query-textbox" appearance="outline">
          <textarea
            rows="4"
            matInput
            placeholder="Type your query here exp: firstName eq 'John'"
            [(ngModel)]="selectedView.oDataQuery"
          ></textarea>
        </mat-form-field>
      </div>
    }
    <div class="filter-panel-action-buttons" style="position: relative">
      @if (!isValid && isApplied) {
        <p class="error-message">
          Please make sure to select all values, or remove the filter before
          applying.
        </p>
      }
      <button
        class="apply-filter"
        mat-flat-button
        color="primary"
        (click)="onApply()"
      >
        Apply Filters
      </button>
      <button class="cancel-button" mat-stroked-button (click)="onCancel()">
        Cancel
      </button>
      @if (!isAdvancedViewMode) {
        <button
          type="button"
          mat-icon-button
          color="primary"
          class="copy-button"
          (click)="onCopyODataFilter()"
          matTooltip="Copy search query to your clipboard"
          aria-label="Copy search query to your clipboard"
          style="position: absolute; right: 0px"
        >
          <mat-icon>integration_instructions</mat-icon>
        </button>
      }
    </div>
  </div>
</div>
